module.exports = __webpack_public_path__ + "img/13-terapie-wine-bar.6dcbe307.jpg";